<img [src]="avatar.originalLink" [style.background-color]="backgroundColor ? backgroundColor : 'trasnparent'" />
